import {
  EverestLoginRequest,
  OCRDetailsFromImageRequest,
  TokenDetailsForLoginRequest
} from "@/central-atoms/everest-fleet-pwa/requests";
import {
  CreateLoginTokenResponse,
  GetHubsOfCity,
  GetLoginDetailsResponse,
  GetOCRDetailsFromImageResponse
} from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import axios, { AxiosResponse } from "axios";

class LoginFlowService {
  static async getHubsOfCity(): Promise<GetHubsOfCity> {
    const token = localStorage.getItem("auth_token");
    const response = await axios.get(
      `${API_BASE_URL}/hubs_of_city`,
      {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    );
    return response?.data?.data || [];
  }

  static async createLogin(
    loginBody: EverestLoginRequest
  ): Promise<CreateLoginTokenResponse> {
    const token = localStorage.getItem("auth_token");
    const response = await axios.post(
      `${API_BASE_URL}/everest/everest_login`,
      loginBody,
      {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    );
    return response.data;
  }

  static async fetchLoginTokenDetails(
    tokenBody: TokenDetailsForLoginRequest,
    accessToken: string | null
  ): Promise<AxiosResponse<GetLoginDetailsResponse>> {
    return axios.post(
      `${API_BASE_URL}/token_details_for_login`,
      tokenBody,
      {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      }
    );
  }

  static async fetchOCRDetailsFromImage(
    payload: OCRDetailsFromImageRequest,
    accessToken: string | null
  ): Promise<AxiosResponse<GetOCRDetailsFromImageResponse>> {
    return axios.post(
      `${API_BASE_URL}/ocr/predict`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      }
    );
  }

  
}

export default LoginFlowService;
